/* eslint-disable no-console */
import { put } from 'redux-saga/effects';
import { Creators } from './action';

import { WebService } from '../services/axios/webServices';
import { localString } from '../localization/localString';
import { apiEndPoints } from '../services/axios/endPoints';
import {
  addLanguage,
  addLanguageDetails,
  getLanguageDetails,
  getLanguageList,
  updateTranslationCache
} from '../constants/language';

export function* getLocaleStringsSaga({ payload }) {
  const { pageId, lang } = payload;

  try {
    yield put(Creators.getLocaleStringsStart());

    const response = yield WebService.get(apiEndPoints.localStringsData, {
      params: {
        lang,
        pageId
      }
    });

    if (response.status >= 200 && response.status < 300) {
      const localeStrings = response.data.data;
      // const localeStrings = localString.en;
      // const localeStrings = localString.Test;
      yield put(Creators.getLocaleStringsSuccess({ localeStrings }));
    } else {
      throw response;
    }
  } catch (error) {
    let payload;
    if (error?.response?.status) {
      switch (error.response.status) {
        case 400:
          payload = {
            error: error.response.data.message
          };
          yield put(Creators.getLocaleStringsFail(payload));
          break;
        case 401:
          payload = {
            error: 'unAuthorized'
          };
          yield put(Creators.getLocaleStringsFail(payload));
          break;
        case 500:
          payload = {
            error: 'Somthing went wrong try later'
          };
          yield put(Creators.getLocaleStringsFail(payload));
          break;
        default:
          payload = {
            error: 'Unable to update. Try again later'
          };
          yield put(Creators.getLocaleStringsFail(payload));
      }
    } else {
      payload = {
        error: error.message
      };

      yield put(Creators.getLocaleStringsFail(payload));
    }
  }
}

export function* getAvailableLanguagesSaga() {
  try {
    yield put(Creators.getAvailableLanguagesStart());

    const response = yield WebService.get(apiEndPoints.listAvailableLanguages);
    if (response.status >= 200 && response.status < 300) {
      const availableLanguages = response.data?.data?.data;
      yield put(Creators.getAvailableLanguagesSuccess({ availableLanguages }));
    } else {
      throw response;
    }
  } catch (error) {
    let payload;
    if (error?.response?.status) {
      switch (error.response.status) {
        case 400:
          payload = {
            error: error.response.data.message
          };
          yield put(Creators.getAvailableLanguagesFail(payload));
          break;
        case 401:
          payload = {
            error: 'unAuthorized'
          };
          yield put(Creators.getAvailableLanguagesFail(payload));
          break;
        case 500:
          payload = {
            error: 'Somthing went wrong try later'
          };
          yield put(Creators.getAvailableLanguagesFail(payload));
          break;
        default:
          payload = {
            error: 'Unable to update. Try again later'
          };
          yield put(Creators.getAvailableLanguagesFail(payload));
      }
    } else {
      payload = {
        error: error.message
      };
      yield put(Creators.getAvailableLanguagesFail(payload));
    }
  }
}

export function* getUserLanguagePreferenceSaga({ payload }) {
  const { userId } = payload;
  try {
    yield put(Creators.getUserLanguagePreferenceStart());

    const response = yield WebService.post(
      apiEndPoints.getUserLanguagePreference,
      {
        userId
      }
    );

    if (response?.status >= 200 && response?.status < 300) {
      const userLanguagePreference = response.data.data?.data;
      yield put(
        Creators.getUserLanguagePreferenceSuccess({
          userLanguagePreference: userLanguagePreference.langKey
        })
      );
      if (userLanguagePreference.langKey !== '') {
        yield put(
          Creators.getLanguageLabel({
            langKey: userLanguagePreference.langKey
          })
        );
      }
    } else {
      throw response;
    }
  } catch (error) {
    let payload;
    if (error?.response?.status) {
      switch (error.response.status) {
        case 400:
          payload = {
            error: error.response.data.message
          };
          yield put(Creators.getUserLanguagePreferenceFail(payload));
          break;
        case 401:
          payload = {
            error: 'unAuthorized'
          };
          yield put(Creators.getUserLanguagePreferenceFail(payload));
          break;
        case 500:
          payload = {
            error: 'Somthing went wrong try later'
          };
          yield put(Creators.getUserLanguagePreferenceFail(payload));
          break;
        default:
          payload = {
            error: 'Unable to update. Try again later'
          };
          yield put(Creators.getUserLanguagePreferenceFail(payload));
      }
    } else {
      payload = {
        error: error.message
      };
      yield put(Creators.getUserLanguagePreferenceFail(payload));
    }
  }
}

export function* getLanguageLabelSaga({ payload }) {
  const { langKey, udpateType = false } = payload;
  try {
    yield put(Creators.getLanguageLabelStart());

    // Open or create IndexedDB
    let versionKey = 0;
    if (!udpateType) {
      const langDetails = yield getLanguageList(langKey);
      if (langDetails.length > 0) {
        versionKey = langDetails[0].versionKey;
      }
    }
    const response = yield WebService.post(
      apiEndPoints.listLangauageLabelText,
      {
        langKey,
        versionKey
      }
    );
    if (response?.status >= 200 && response?.status < 300) {
      const langauageLabel = response.data.data?.data;
      const newVersionKey = langauageLabel.versionKey;
      if (langauageLabel.languageData.length > 0 && !udpateType) {
        yield addLanguageDetails(langauageLabel.languageData);
        yield addLanguage({
          langKey,
          versionKey: newVersionKey
        });
        yield updateTranslationCache(langKey);
      }
      if (langauageLabel.languageData.length === 0 && !udpateType) {
        yield updateTranslationCache(langKey);
      }
      if (udpateType) {
        yield put(
          Creators.getLanguageLabelSuccess({
            langauageLabel: langauageLabel.languageData
          })
        );
      }
    } else {
      throw response;
    }
  } catch (error) {
    console.log('error', error);
  }
}

export function* updateUserLanguagePreferenceSaga({ payload }) {
  const { userId, langKey } = payload;
  try {
    yield put(Creators.updateUserLanguagePreferenceStart());

    const response = yield WebService.post(
      apiEndPoints.updateUserLanguagePreference,
      {
        userId,
        langKey
      }
    );

    if (response?.status >= 200 && response?.status < 300) {
      yield put(
        Creators.updateUserLanguagePreferenceSuccess(response?.data?.data)
      );
      yield put(Creators.getUserLanguagePreference({ userId }));
    } else {
      throw response;
    }
  } catch (error) {
    let payload;
    if (error?.response?.status) {
      switch (error.response.status) {
        case 400:
          payload = {
            error: error.response.data.message
          };
          yield put(Creators.updateUserLanguagePreferenceFail(payload));
          break;
        case 401:
          payload = {
            error: 'unAuthorized'
          };
          yield put(Creators.updateUserLanguagePreferenceFail(payload));
          break;
        case 500:
          payload = {
            error: 'Somthing went wrong try later'
          };
          yield put(Creators.updateUserLanguagePreferenceFail(payload));
          break;
        default:
          payload = {
            error: 'Unable to update. Try again later'
          };
          yield put(Creators.updateUserLanguagePreferenceFail(payload));
      }
    } else {
      payload = {
        error: error.message
      };
      yield put(Creators.updateUserLanguagePreferenceFail(payload));
    }
  }
}

export function* addUpdateLanguageLabelTextSaga({ payload }) {
  const { langKey, records } = payload;
  try {
    yield put(Creators.addUpdateLanguageLabelTextStart());

    const response = yield WebService.post(
      apiEndPoints.addUpdateLangauageLabelText,
      {
        langKey,
        records
      }
    );

    if (response?.status >= 200 && response?.status < 300) {
      yield put(
        Creators.addUpdateLanguageLabelTextSuccess(response?.data?.data)
      );
      yield put(Creators.getLanguageLabel({ langKey, udpateType: true }));
    } else {
      throw response;
    }
  } catch (error) {
    let payload;
    if (error?.response?.status) {
      switch (error.response.status) {
        case 400:
          payload = {
            error: error.response.data.message
          };
          yield put(Creators.addUpdateLanguageLabelTextFail(payload));
          break;
        case 401:
          payload = {
            error: 'unAuthorized'
          };
          yield put(Creators.addUpdateLanguageLabelTextFail(payload));
          break;
        case 500:
          payload = {
            error: 'Somthing went wrong try later'
          };
          yield put(Creators.addUpdateLanguageLabelTextFail(payload));
          break;
        default:
          payload = {
            error: 'Unable to update. Try again later'
          };
          yield put(Creators.addUpdateLanguageLabelTextFail(payload));
      }
    } else {
      payload = {
        error: error.message
      };
      yield put(Creators.addUpdateLanguageLabelTextFail(payload));
    }
  }
}

export function* syncLanguageLabelsSaga({ payload }) {
  const { langKey, records } = payload;
  try {
    yield put(Creators.syncLanguageLabelsStart());

    const response = yield WebService.post(apiEndPoints.syncLanguageLabels, {
      langKey,
      records
    });

    if (response?.status >= 200 && response?.status < 300) {
      yield put(Creators.syncLanguageLabelsSuccess(response?.data?.data));
      yield put(Creators.getLanguageLabel({ langKey, udpateType: true }));
    } else {
      throw response;
    }
  } catch (error) {
    let payload;
    if (error?.response?.status) {
      switch (error.response.status) {
        case 400:
          payload = {
            error: error.response.data.message
          };
          yield put(Creators.syncLanguageLabelsFail(payload));
          break;
        case 401:
          payload = {
            error: 'unAuthorized'
          };
          yield put(Creators.syncLanguageLabelsFail(payload));
          break;
        case 500:
          payload = {
            error: 'Somthing went wrong try later'
          };
          yield put(Creators.syncLanguageLabelsFail(payload));
          break;
        default:
          payload = {
            error: 'Unable to update. Try again later'
          };
          yield put(Creators.syncLanguageLabelsFail(payload));
      }
    } else {
      payload = {
        error: error.message
      };
      yield put(Creators.syncLanguageLabelsFail(payload));
    }
  }
}

// export function* updateUserLanguagePreferenceSaga({ payload }) {
//   const { userId, langKey } = payload;
//   try {
//     yield put(Creators.updateUserLanguagePreferenceStart());

//     const response = yield WebService.post(
//       apiEndPoints.updateUserLanguagePreference,
//       {
//         userId,
//         langKey
//       }
//     );

//     if (response?.status >= 200 && response?.status < 300) {
//       yield put(Creators.updateUserLanguagePreferenceSuccess());
//     } else {
//       throw response;
//     }
//   } catch (error) {
//     let payload;
//     if (error?.response?.status) {
//       switch (error.response.status) {
//         case 400:
//           payload = {
//             error: error.response.data.message
//           };
//           yield put(Creators.updateUserLanguagePreferenceFail(payload));
//           break;
//         case 401:
//           payload = {
//             error: 'unAuthorized'
//           };
//           yield put(Creators.updateUserLanguagePreferenceFail(payload));
//           break;
//         case 500:
//           payload = {
//             error: 'Somthing went wrong try later'
//           };
//           yield put(Creators.updateUserLanguagePreferenceFail(payload));
//           break;
//         default:
//           payload = {
//             error: 'Unable to update. Try again later'
//           };
//           yield put(Creators.updateUserLanguagePreferenceFail(payload));
//       }
//     } else {
//       payload = {
//         error: error.message
//       };
//       yield put(Creators.updateUserLanguagePreferenceFail(payload));
//     }
//   }
// }

export function* addUpdateLangauageLabelTextSaga({ payload }) {
  const { langKey, records } = payload;
  try {
    yield put(Creators.addUpdateLangauageLabelTextStart());

    const response = yield WebService.post(
      apiEndPoints.addUpdateLangauageLabelText,
      {
        langKey,
        records
      }
    );

    if (response?.status >= 200 && response?.status < 300) {
      yield put(Creators.addUpdateLangauageLabelTextSuccess());
    } else {
      throw response;
    }
  } catch (error) {
    let payload;
    if (error?.response?.status) {
      switch (error.response.status) {
        case 400:
          payload = {
            error: error.response.data.message
          };
          yield put(Creators.addUpdateLangauageLabelTextFail(payload));
          break;
        case 401:
          payload = {
            error: 'unAuthorized'
          };
          yield put(Creators.addUpdateLangauageLabelTextFail(payload));
          break;
        case 500:
          payload = {
            error: 'Somthing went wrong try later'
          };
          yield put(Creators.addUpdateLangauageLabelTextFail(payload));
          break;
        default:
          payload = {
            error: 'Unable to update. Try again later'
          };
          yield put(Creators.addUpdateLangauageLabelTextFail(payload));
      }
    } else {
      payload = {
        error: error.message
      };
      yield put(Creators.addUpdateLangauageLabelTextFail(payload));
    }
  }
}
